import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { useCallback, useMemo } from "react";
import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";
import { UsuarioDropDown } from "../../../../../../common/domain/models/usuario_dropdown";

import CascateList from "../../../../../../common/components/cascate_list";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DefaultInput from "../../../../../../common/components/default_input";

/**
 * Header
 */

type Props = {
  tipoPesquisa: number;
  valueField: string;
  status: number;
  usuarios: UsuarioDropDown[];
  onTipoPesquisaChange: (novoTipoPesquisa: number) => void;
  onValueFieldChange: (valueField: string) => void;
  onStatusChange: (novoStatus: number) => void;
  onClearFilters: () => void;
};

export const Header = ({
  tipoPesquisa,
  valueField,
  status,
  usuarios,
  onTipoPesquisaChange,
  onValueFieldChange,
  onStatusChange,
  onClearFilters,
}: Props) => {

  const selectedUsuario = useMemo(() => {
    const usuarioId = valueField.length !== 0 ? Number(valueField) : null;
    return tipoPesquisa === 4 ? usuarios.find(x => x.idUsuario === usuarioId) ?? null : null;
  }, [
    tipoPesquisa,
    valueField,
    usuarios,
  ]);

  const handleTipoPesquisaChange = useCallback((e: SelectChangeEvent<number>) => {
    onTipoPesquisaChange(typeof e.target.value === "string" ? parseInt(e.target.value) : e.target.value)
  }, [onTipoPesquisaChange]);

  const handleValueFieldChange = useCallback((e: UsuarioDropDown | null) => {
    const idUsuario = e?.idUsuario ?? null;
    onValueFieldChange(idUsuario !== null ? idUsuario.toString() : '');
  }, [
    onValueFieldChange,
  ]);

  const handleStatusChange = useCallback((e: SelectChangeEvent<number>) => {
    onStatusChange(typeof e.target.value === "string" ? parseInt(e.target.value) : e.target.value);
  }, [onStatusChange]);

  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 grid-flow-row-dense">
            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">
              <FormControl size="small" sx={{ width: "275px" }}>
                <InputLabel id="modulo-dashboard" size="small">Pesquisar por</InputLabel>
                <Select
                  size="small"
                  labelId="modulo-dashboard"
                  label="Pesquisar por"
                  value={tipoPesquisa}
                  onChange={handleTipoPesquisaChange}>
                  <MenuItem value={2}>Descrição</MenuItem>
                  <MenuItem value={1}>Nome do Arquivo</MenuItem>
                  <MenuItem value={3}>Local</MenuItem>
                  <MenuItem value={4}>Incluído Por</MenuItem>
                </Select>
              </FormControl>

              <div className="w-full">
                {
                  tipoPesquisa !== 4 ? (
                    <DefaultInput
                      label="Pesquisar"
                      name="search_by_value_field"
                      value={valueField}
                      onChangeValue={onValueFieldChange} />
                  ) : (
                    <DefaultAutocomplete
                      value={selectedUsuario}
                      options={usuarios}
                      getOptionLabel={x => x.nome}
                      getOptionKey={x => x.idUsuario}
                      onChange={handleValueFieldChange} />
                  )
                }

              </div>
            </div>

            <div className="flex col-span-1 md:col-span-2 lg:col-span-1 gap-1">
              <FormControl size="small" fullWidth>
                <InputLabel id="modulo-dashboard"></InputLabel>
                <Select
                  labelId="modulo-dashboard"
                  label=""
                  value={status}
                  onChange={handleStatusChange}>
                  <MenuItem value={1}>Todos</MenuItem>
                  <MenuItem value={2}>Atual</MenuItem>
                  <MenuItem value={3}>Obsoletos</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>
          <div className="w-full flex justify-end">
            <div className="w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={onClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>
        </div>
      </CascateList>
    </>
  );
}